module.exports = "<!-- ko ifnot: koHasHtml -->\r\n<span style=\"position: static;\" data-bind=\"text: koRenderedHtml\"></span>\r\n<!-- /ko -->\r\n<!-- ko if: koHasHtml -->\r\n<span style=\"position: static;\" data-bind=\"html: koRenderedHtml\"></span>\r\n<!-- /ko -->\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/knockout/components/string-viewer.html
// module id = 117
// module chunks = 0